import React, { useState } from 'react'
import styles from './OurServicesSection.module.scss'
import { ConstructionIcon } from 'components/CustomIcons'
import { 
  EcommerceHeaderIcon, 
  GamingHeaderIcon, 
  TechnologyHeaderIcon, 
  CommunityHeaderIcon, 
  EntertainmentHeaderIcon, 
  TravelHeaderIcon, 
  ComingSoonHeaderIcon,
  AllServicesIcon,
  EcommerceHeaderIconWhite,
  GamingHeaderIconWhite,
  TechnologyHeaderIconWhite,
  CommunityHeaderIconWhite,
  EntertainmentHeaderIconWhite,
  TravelHeaderIconWhite,
  ComingSoonHeaderIconWhite
} from 'components/CustomIcons/CategoryIcons'

// Import SVG Icons
import { ReactComponent as ShopIcon } from 'assets/icons/services/shop.svg'
import { ReactComponent as FoodIcon } from 'assets/icons/services/food.svg'
import { ReactComponent as GamingIcon } from 'assets/icons/services/gaming.svg'
import { ReactComponent as ITIcon } from 'assets/icons/services/it.svg'
import { ReactComponent as CommunityIcon } from 'assets/icons/services/community.svg'
import { ReactComponent as MovieIcon } from 'assets/icons/services/movie.svg'
import { ReactComponent as AnimeIcon } from 'assets/icons/services/anime.svg'
import { ReactComponent as EventsIcon } from 'assets/icons/services/events.svg'
import { ReactComponent as MediaIcon } from 'assets/icons/services/media.svg'
import { ReactComponent as TourismIcon } from 'assets/icons/services/tourism.svg'
import { ReactComponent as MedicineIcon } from 'assets/icons/services/medicine.svg'
import { ReactComponent as DonationsIcon } from 'assets/icons/services/donations.svg'

// Import block images
import animeImg from 'assets/imagesblock/anime.png'
import donatsImg from 'assets/imagesblock/donats.png'
import mediaImg from 'assets/imagesblock/media.png'
import movieImg from 'assets/imagesblock/movie.png'
import serversImg from 'assets/imagesblock/servers.png'

const OurServicesSection = ({ onOpenService }) => {
  const [activeCategory, setActiveCategory] = useState('all')

  const iconComponents = {
    shop: ShopIcon,
    food: FoodIcon,
    servers: GamingIcon,
    it: ITIcon,
    community: CommunityIcon,
    movie: MovieIcon,
    anime: AnimeIcon,
    events: EventsIcon,
    media: MediaIcon,
    tourism: TourismIcon,
    medicine: MedicineIcon,
    donations: DonationsIcon
  }

  const blockImages = {
    servers: serversImg,
    anime: animeImg,
    media: mediaImg,
    movie: movieImg,
    donations: donatsImg
  }

  const serviceCategories = [
    {
      id: 'gaming',
      name: 'Игровые решения',
      icon: GamingIcon,
      headerIcon: GamingHeaderIcon,
      whiteHeaderIcon: GamingHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
      services: [
        {
          id: 'servers',
          title: 'Игровые сервера',
          description: 'Хостинг игровых серверов высокого качества',
          icon: 'servers',
          color: '#9C27B0',
          features: ['DDoS защита', 'SSD накопители', 'Низкий пинг']
        }
      ]
    },
    {
      id: 'ecommerce',
      name: 'E-commerce',
      icon: ShopIcon,
      headerIcon: EcommerceHeaderIcon,
      whiteHeaderIcon: EcommerceHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #FF6B35 0%, #FF8C42 100%)',
      services: [
        {
          id: 'donations',
          title: 'Донаты',
          description: 'Пополнение игровых валют и покупка ваучеров',
          icon: 'donations',
          color: '#FF6B35',
          features: ['Моментальное пополнение', 'Игровые валюты', 'Коды ваучеров']
        }
      ]
    },
    {
      id: 'entertainment',
      name: 'Развлечения',
      icon: MovieIcon,
      headerIcon: EntertainmentHeaderIcon,
      whiteHeaderIcon: EntertainmentHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #F44336 0%, #D32F2F 100%)',
      services: [
        {
          id: 'movie',
          title: 'Фильмы',
          description: 'База данных фильмов и рейтинги',
          icon: 'movie',
          color: '#F44336',
          features: ['Огромная коллекция', 'HD качество', 'Рекомендации']
        },
        {
          id: 'anime',
          title: 'Аниме',
          description: 'Каталог аниме и манги',
          icon: 'anime',
          color: '#673AB7',
          features: ['Субтитры', 'Новинки', 'Рейтинги']
        },
        {
          id: 'media',
          title: 'Медиа',
          description: 'Новости, обзоры и игровой контент',
          icon: 'media',
          color: '#795548',
          features: ['Актуальные новости', 'Обзоры', 'Статьи']
        }
      ]
    },
    {
      id: 'coming-soon',
      name: 'Скоро',
      icon: MedicineIcon,
      headerIcon: ComingSoonHeaderIcon,
      whiteHeaderIcon: ComingSoonHeaderIconWhite,
      gradient: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
      services: [
        {
          id: 'shop',
          title: 'Интернет-магазин',
          description: 'Покупайте товары онлайн с быстрой доставкой',
          icon: 'shop',
          color: '#4CAF50',
          inDevelopment: true,
          features: ['Широкий ассортимент', 'Быстрая доставка', 'Безопасные платежи']
        },
        {
          id: 'food',
          title: 'Доставка еды',
          description: 'Поиск ресторанов и заказ еды',
          icon: 'food',
          color: '#FF9800',
          inDevelopment: true,
          features: ['Лучшие рестораны', 'Быстрая доставка', 'Онлайн оплата']
        },
        {
          id: 'it',
          title: 'IT услуги',
          description: 'Разработка и техническая поддержка',
          icon: 'it',
          color: '#2196F3',
          inDevelopment: true,
          features: ['Разработка ПО', 'Консультации', 'Поддержка 24/7']
        },
        {
          id: 'community',
          title: 'Сообщество',
          description: 'Общайтесь и делитесь опытом',
          icon: 'community',
          color: '#E91E63',
          inDevelopment: true,
          features: ['Форумы', 'Чаты', 'Группы по интересам']
        },
        {
          id: 'events',
          title: 'Мероприятия',
          description: 'Участвуйте в интересных событиях',
          icon: 'events',
          color: '#FF5722',
          inDevelopment: true,
          features: ['Онлайн события', 'Встречи', 'Конкурсы']
        },
        {
          id: 'tourism',
          title: 'Туризм',
          description: 'Бронируйте туры и путешествия',
          icon: 'tourism',
          color: '#00BCD4',
          inDevelopment: true,
          features: ['Туры по миру', 'Лучшие отели', 'Гиды']
        },
        {
          id: 'medicine',
          title: 'Медицина',
          description: 'Сообщество медиков',
          icon: 'medicine',
          color: '#4CAF50',
          comingSoon: true,
          features: ['Консультации', 'Записи к врачам', 'База знаний']
        }
      ]
    }
  ]

  const filteredCategories = activeCategory === 'all' 
    ? serviceCategories 
    : serviceCategories.filter(cat => cat.id === activeCategory)

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* <div className={styles.header}>
          <h2 className={styles.title}>Экосистема сервисов NCORE</h2>
          <p className={styles.subtitle}>
            Откройте для себя широкий спектр услуг платформы NCORE
          </p>
        </div> */}

        {/* Category Filter */}
        <div className={styles.categoryFilter}>
          <button 
            className={`${styles.filterButton} ${activeCategory === 'all' ? styles.active : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            <AllServicesIcon className={styles.filterIcon} size={20} />
            <span>Все сервисы</span>
          </button>
          {serviceCategories.map(category => {
            const CategoryHeaderIcon = category.headerIcon
            return (
              <button 
                key={category.id}
                className={`${styles.filterButton} ${activeCategory === category.id ? styles.active : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <CategoryHeaderIcon className={styles.filterIcon} size={22} />
                <span>{category.name}</span>
              </button>
            )
          })}
        </div>

        {/* Service Categories */}
        <div className={styles.categoriesWrapper}>
          {filteredCategories.map((category, categoryIndex) => (
            <div key={category.id} className={styles.categoryBlock} style={{ animationDelay: `${categoryIndex * 0.1}s` }}>
              <div className={styles.categoryHeader}>
                <div className={styles.categoryBadge} style={{ background: category.gradient }}>
                  <div className={styles.categoryIconWrapper}>
                    {React.createElement(category.whiteHeaderIcon, { className: styles.categoryIcon, size: 28 })}
                  </div>
                  <h3 className={styles.categoryName}>{category.name}</h3>
                </div>
                <div className={styles.categoryLine}></div>
              </div>
              
              <div className={styles.servicesGrid}>
                {category.services.map((service, serviceIndex) => {
                  const ServiceIcon = iconComponents[service.icon]
                  return (
                    <div
                      key={service.id}
                      className={`${styles.serviceCard} ${service.inDevelopment ? styles.inDevelopment : ''} ${service.comingSoon ? styles.comingSoon : ''}`}
                      onClick={() => !service.comingSoon && onOpenService(service.id)}
                      style={{ 
                        '--accent-color': service.color,
                        animationDelay: `${(categoryIndex * 0.1) + (serviceIndex * 0.05)}s`
                      }}
                    >
                      <div className={styles.cardGlow} style={{ background: service.color }}></div>
                      
                      <div className={styles.cardContent}>
                        <div className={styles.cardLeft}>
                          <ServiceIcon className={styles.serviceIcon} style={{ color: service.color }} />
                          <h3 className={styles.serviceTitle}>{service.title}</h3>
                          <p className={styles.serviceDescription}>{service.description}</p>
                          
                          <div className={styles.featuresWrapper}>
                            {service.features?.map((feature, idx) => (
                              <span 
                                key={idx} 
                                className={styles.featureTag}
                                style={{ '--accent-color': service.color }}
                              >
                                <span className={styles.featureCheck}>✓</span>
                                {feature}
                              </span>
                            ))}
                          </div>

                          {service.comingSoon ? (
                            <div className={styles.developmentBadge}>
                              <ConstructionIcon className={styles.devIcon} size={18} />
                              В разработке
                            </div>
                          ) : (
                            <>
                              <div className={styles.cardFooter}>
                                <span className={styles.serviceLink}>Открыть сервис</span>
                                <span className={styles.serviceArrow}>→</span>
                              </div>
                              {service.inDevelopment && (
                                <div className={styles.developmentNote}>
                                  <ConstructionIcon className={styles.devIcon} size={16} />
                                  Данный раздел ещё в разработке
                                </div>
                              )}
                            </>
                          )}
                        </div>

                        {blockImages[service.id] && (
                          <div className={styles.cardRight}>
                            <img 
                              src={blockImages[service.id]} 
                              alt={service.title}
                              className={styles.blockImage}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default OurServicesSection